// extracted by mini-css-extract-plugin
module.exports = {"mediaAnswerWrapper":"_normal--mediaAnswerWrapper---D2w-","mediaAnswer":"_normal--mediaAnswer--3cOMH"};